export default __webpack_public_path__ + "static/media/Adictic.56a312c6.svg";